export var NONE = 'none';
export var CLEAR = 'clear';
export var ASC = 'asc';
export var DESC = 'desc';
export default {
  NONE: NONE,
  CLEAR: CLEAR,
  ASC: ASC,
  DESC: DESC
};